import { render, staticRenderFns } from "./NewEmployeeView.vue?vue&type=template&id=572ca8f2&"
import script from "./NewEmployeeView.vue?vue&type=script&lang=js&"
export * from "./NewEmployeeView.vue?vue&type=script&lang=js&"
import style0 from "./NewEmployeeView.vue?vue&type=style&index=0&id=572ca8f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports